<rid-categorise-yes-no
  class="h-dvh"
  [questions]="[
    {
      id: 'q1',
      question: 'Rijmen deze woorden?',
      options: [
        { type: 'WORD', word: 'fruit' },
        { type: 'WORD', word: 'kluit' },
      ],
      answer: 'YES',
    },
    {
      id: 'q1.1',
      question: 'Zit er een fopletter in dit woord?',
      options: [
        {
          type: 'AUDIO',
          src: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/JEOE5HvotZVLUtbnIaXb0.mp3',
        },
      ],
      answer: 'YES',
    },
    {
      id: 'q2',
      question: 'Behoren deze woorden tot dezelfde categorie?',
      options: [
        { type: 'WORD', word: 'appel' },
        { type: 'WORD', word: 'stoel' },
      ],
      answer: 'NO',
    },
    {
      id: 'q3',
      question: 'Bevat dit woord een dubbelzetter?',
      options: [{ type: 'WORD', word: 'stoel' }],
      answer: 'NO',
    },
    {
      id: 'q4',
      question: 'Bevat deze zin een dubbelzetter?',
      options: [{ type: 'SENTENCE', sentence: 'de kat is blij' }],
      answer: 'NO',
    },
  ]"
  (finished)="$router.navigate(['/mechanics/sorting/yes-or-no'])"
/>
